import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { NbButtonModule, NbCardModule, NbDialogRef, NbDialogService, NbIconModule, NbListModule } from '@nebular/theme';
import { FailedJobInsightComponent } from '../failed-job-insight/failed-job-insight.component';

@Component({
  selector: 'app-failed-job-insight-list',
  templateUrl: './failed-job-insight-list.component.html',
  styleUrls: ['./failed-job-insight-list.component.css'],
  imports: [NbCardModule, NbIconModule, NbButtonModule, NgIf, NbListModule, NgFor, DatePipe]
})
export class FailedJobInsightListComponent {
  public failedJobsList: any;

  constructor(
    protected ref: NbDialogRef<FailedJobInsightListComponent>,
    private dialogService: NbDialogService
  ) {}

  public close() {
    this.ref.close();
  }

  public viewFailedJob(event) {
    this.dialogService.open(FailedJobInsightComponent, {
      closeOnEsc: false,
      closeOnBackdropClick: false,
      context: {
        failedJob: event
      }
    });
  }
}
